/**
 * @module FE-CU37_ユーザー管理画面
 */
import Header from '../../components/header/Header.vue';
import ListPanel from '../../components/listPanel/ListPanel.vue';
import NormalButton from '../../components/button/Normal.vue';
import MobileFooter from '../../components/footer/MobileFooter.vue';
import PcPageTitle from '../../components/pcPageTitle/PcPageTitle.vue';
import BreadCrumbList from '../../components/breadCrumb/List.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import CONSTANTS from '../../constants';

const PAGE_ID = 'FE-CU37';

export default {
  name: 'UserManagement',
  components: {
    Header,
    ListPanel,
    NormalButton,
    MobileFooter,
    PcPageTitle,
    BreadCrumbList,
    PCFooter,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t('$vuetify.FECU37ユーザー管理画面.ユーザー管理'),
      hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU37ユーザー管理画面.C0001'),
      isSPBackgroundColor: false,
      isDisabled: true,
      clientNumber: '',
      displayAreaTitle: {
        place: '',
        type: '',
        typeIsBefore: false,
      },
      displayDistrictInfo: {},
      panelResult: [],
      userResult: [],
      origin: { userId: '', mail: '', userType: 1 },
      backState: '',
      width: 0,
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU37ユーザー管理画面.ユーザー管理'),
        hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU37ユーザー管理画面.C0001'),
        displayAreaTitle: {
          place: '',
          type: '',
          typeIsBefore: true,
        },
      };
    },
  },
  /** @type {Methods} */
  methods: {
    active: function () {
      this.isActive = !this.isActive;
    },
    /**
     * メインユーザー移譲ボタン押下時処理
     */
    goTransferPage() {
      this.$store.state.origin = { ...this.origin };
      this.$router.push({
        name: 'MainUserTransfer',
        params: { origin: this.origin },
      });
    },
    /**
     * 初期表示(対象地区)API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストパラメータ
     * @param {*} method メソッドパラメータ
     * @returns apiData レスポンス
     */
    APP_CU3701: async function (param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      let hasError = false;
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // サンプルデータ(対象地区)
            // apiData = {
            //   contentsInfo: {
            //     displayDistrictInfo: {
            //       usagePlan: 0, // 0: オンライン監視プラン 1: 依頼かけつけプラン 2:セルフ監視プラン
            //       customerNumber: "51-1234567", // お客様番号
            //       securityDestinationName: "警備先1", // 警備先名
            //       districtSplitNumber: "0001", // 地区番号
            //       districtSplitName: "地区名1234", // 地区名
            //       displayDistrictNickname: "自宅",
            //     },
            //     userInfoList: [
            //       {
            //         mail: "aaaiii1@example.com",
            //         name: "警備 太郎",
            //         displayDistrictUserType: 1,
            //       },
            //       {
            //         mail: "aaaiii2@example.com",
            //         name: "警備 次郎",
            //         displayDistrictUserType: 2,
            //       },
            //     ],
            //   },
            // };
          },
          (error) => {
            hasError = true;
            if (error.message.includes('403')) {
              this.$router.replace({
                path: '/top',
              });
              return;
            } else {
              this.$_abnormality(error.response.status);
              return;
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      if (hasError) {
        return;
      }

      const targetItem = apiData.contentsInfo.displayDistrictInfo;

      // データ整形
      const labels = {
        usagePlan: '$vuetify.FECU37ユーザー管理画面.対象地区詳細表示領域.利用プラン',
        customerNumber: '$vuetify.FECU37ユーザー管理画面.対象地区詳細表示領域.お客様番号',
        securityDestinationName: '$vuetify.FECU37ユーザー管理画面.対象地区詳細表示領域.警備先名',
        districtSplitNumber: '$vuetify.FECU37ユーザー管理画面.対象地区詳細表示領域.地区番号',
        districtSplitName: '$vuetify.FECU37ユーザー管理画面.対象地区詳細表示領域.地区名',
      };
      const targetKeys = [
        'usagePlan',
        'customerNumber',
        'securityDestinationName',
        'districtSplitNumber',
        'districtSplitName',
      ];
      const planTitles = {
        [CONSTANTS.HOME_SECURITY_USAGE_PLAN.ONLINE_MONITORING_PLAN]:
          '$vuetify.コード.利用プランID.オンライン監視プラン',
        [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN]:
          '$vuetify.コード.利用プランID.依頼かけつけプラン',
        [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN_NO_DEVICE]:
          '$vuetify.コード.利用プランID.依頼かけつけプラン',
        [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN]:
          '$vuetify.コード.利用プランID.セルフ監視プラン',
        [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN_NO_DEVICE]:
          '$vuetify.コード.利用プランID.セルフ監視プラン',
      };
      // ListPanelコンポーネント用に整形
      Object.keys(targetItem).map((key) => {
        if (targetKeys.includes(key)) {
          let text = targetItem[key];
          if (key === 'usagePlan') {
            text = planTitles[targetItem[key]];
          }
          if (key === 'districtSplitNumber') {
            if (targetItem[key] === '    ') {
              text = '$vuetify.FECU37ユーザー管理画面.メイン地区';
            }
            if (targetItem[key] === '') {
              return;
            }
          }
          this.panelResult = [
            ...this.panelResult,
            {
              title: labels[key],
              text: text,
            },
          ];
        }
      });
      // ユーザー表示用にデータを設定
      this.displayAreaTitle = {
        place: `- ${apiData.contentsInfo.displayDistrictInfo.displayDistrictNickname}`,
        type: '$vuetify.FECU37ユーザー管理画面.対象地区詳細表示領域.対象地区',
        typeIsBefore: true,
      };
      this.userResult = apiData.contentsInfo.userInfoList;

      apiData.contentsInfo.userInfoList.map((user) => {
        if (user.displayDistrictUserType == 1) {
          this.origin['name'] = user.name;
          this.origin['userId'] = user.mail;
          this.origin['userType'] = user.displayDistrictUserType;
        }
      });

      return apiData;
    },
    /**
     * 初期表示(カメラ)API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストパラメータ
     * @param {*} method メソッドパラメータ
     * @returns apiData レスポンス
     */
    APP_CU3702: async function (param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      let hasError = false;
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // サンプルデータ(カメラ)

            // apiData = {
            //   contentsInfo: {
            //     cameraInfo: {
            //       usagePlan: 1, // 0: オンライン監視プラン 1: 依頼かけつけプラン 2:セルフ監視プラン
            //       customerNumber: "51-1234567", // お客様番号
            //       securityDestinationName: "警備先1", // 警備先名
            //       districtSplitNumber: "0001", // 地区番号
            //       districtSplitName: "地区1", // 地区名
            //       displayDistrictNickname: "自宅",
            //       cameraNickname: "リビングカメラ",
            //       deviceID: "123456",
            //       userInfoList: [
            //         {
            //           mail: "aaaiii1@example.com",
            //           name: "警備 太郎",
            //           cameraUserType: 1, // 1:メインユーザー
            //         },
            //         {
            //           mail: "aaaiii2@example.com",
            //           name: "警備 次郎",
            //           cameraUserType: 2, // 2:サブユーザー
            //         },
            //       ],
            //     },
            //   },
            // };
          },
          (error) => {
            hasError = true;
            if (error.message.includes('403')) {
              this.$router.replace({
                path: '/top',
              });
              return;
            } else {
              this.$_abnormality(error.response.status);
              return;
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      if (hasError) {
        return;
      }

      const targetItem = apiData.contentsInfo.cameraInfo;

      // データ整形
      const labels = {
        usagePlan: '$vuetify.FECU37ユーザー管理画面.対象地区詳細表示領域.利用プラン',
        customerNumber: '$vuetify.FECU37ユーザー管理画面.対象地区詳細表示領域.お客様番号',
        securityDestinationName: '$vuetify.FECU37ユーザー管理画面.対象地区詳細表示領域.警備先名',
        districtSplitNumber: '$vuetify.FECU37ユーザー管理画面.対象地区詳細表示領域.地区番号',
        districtSplitName: '$vuetify.FECU37ユーザー管理画面.対象地区詳細表示領域.地区名',
        displayDistrictNickName:
          '$vuetify.FECU37ユーザー管理画面.カメラ詳細表示領域.ニックネーム対象地区',
      };
      const targetKeys = [
        'usagePlan',
        'customerNumber',
        'securityDestinationName',
        'districtSplitNumber',
        'districtSplitName',
        'displayDistrictNickName',
      ];
      const planTitles = {
        [CONSTANTS.CAMERA_USAGE_PLAN.ONLINE_MONITORING_PLAN]:
          '$vuetify.コード.利用プランID.オンライン監視プラン',
        [CONSTANTS.CAMERA_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN]:
          '$vuetify.コード.利用プランID.カメラ依頼かけつけプラン',
        [CONSTANTS.CAMERA_USAGE_PLAN.SELF_MONITORING_PLAN]:
          '$vuetify.コード.利用プランID.カメラセルフ監視プラン',
      };
      // ListPanelコンポーネント用に整形
      Object.keys(targetItem).map((key) => {
        if (targetKeys.includes(key)) {
          let text = targetItem[key];
          if (key === 'usagePlan') {
            text = planTitles[targetItem[key]];
          }
          if (key === 'districtSplitNumber') {
            if (targetItem[key] === '    ') {
              text = '$vuetify.FECU37ユーザー管理画面.メイン地区';
            }
            if (targetItem[key] === '') {
              return;
            }
          }
          this.panelResult = [
            ...this.panelResult,
            {
              title: labels[key],
              text: text,
            },
          ];
        }
      });
      // ユーザー表示用にデータを設定
      this.displayAreaTitle = {
        place: `- ${apiData.contentsInfo.cameraInfo.cameraNickName}`,
        type: '$vuetify.FECU37ユーザー管理画面.カメラ詳細表示領域.カメラ',
        typeIsBefore: true,
      };
      this.userResult = apiData.contentsInfo.userInfoList;

      apiData.contentsInfo.userInfoList.map((user) => {
        if (user.cameraUserType == 1) {
          this.origin = user;
          this.origin['name'] = user.name;
          this.origin['userId'] = user.mail;
          this.origin['userType'] = user.cameraUserType;
        }
      });

      return apiData;
    },
    /**
     * 画面遷移処理(history上書き)
     * @param {String} url 画面遷移先パス
     */
    replace(url) {
      this.$router.replace({
        path: url,
      });
    },
    /**
     * 画面遷移処理(history追加)
     * @param {String} url 画面遷移先パス
     */
    push(url) {
      this.$router.push({
        path: url,
      });
    },
    /**
     * 戻るボタン押下時処理
     */
    replaceBack: function () {
      this.$store.commit('setBackButtonFlag', { backButtonFlag: true });
      this.$router.back();
    },
    /**
     * 変更ボタン押下時処理
     * @param {*} user
     */
    goSubUserAuthorityChange(user) {
      // save subUserId to store for keep value when click back button in browser
      this.$store.commit('setSubUserId', {
        subUserId: user.mail,
      });
      this.$router.push({
        name: 'SubUserAuthorityChange',
        params: { subUserId: user.mail },
      });
    },

    /**
     * 変更ボタンの活性制御
     * @return {boolean}
     */
    canClickChangeButton() {
      if (this.$store.state.currentDisplayType == 1) {
        if (this.$store.state.displayDistrictUserType == 1) {
          return false;
        } else {
          return true;
        }
      } else if (this.$store.state.currentDisplayType == 2) {
        if (this.$store.state.cameraUserType == 1) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    /**
     * ボタンの表示制御
     * @return {boolean}
     */
    displayable(user) {
      if (this.$store.state.currentDisplayType == 1) {
        if (user.displayDistrictUserType == 1) {
          return false;
        } else {
          return true;
        }
      } else if (this.$store.state.currentDisplayType == 2) {
        if (user.cameraUserType == 1) {
          return false;
        } else {
          return true;
        }
      }
    },
    /**
     * ボタンの活性制御(サブユーザー追加、メインユーザー移譲)
     * @return {boolean}
     */
    calcDisabled() {
      if (this.$store.state.currentDisplayType == 1) {
        if (this.$store.state.displayDistrictUserType == 1) {
          return false;
        } else {
          return true;
        }
      } else if (this.$store.state.currentDisplayType == 2) {
        if (this.$store.state.cameraUserType == 1) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    /**
     * ラベル項目の幅を変更
     * @param {*} width 幅
     */
    changeItemLabelWidth(width) {
      this.width = width;
    },
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }

    this.width =
      this.$mq === 'pc' ? CONSTANTS.LIST_PANEL_LABEL_WIDTH.PC : CONSTANTS.LIST_PANEL_LABEL_WIDTH.SP;

    // 画面サイズ変更
    this.$watch('$mq', function () {
      this.changeItemLabelWidth(
        this.$mq === 'pc'
          ? CONSTANTS.LIST_PANEL_LABEL_WIDTH.PC
          : CONSTANTS.LIST_PANEL_LABEL_WIDTH.SP
      );
    });

    let param =
      this.$store.state.currentDisplayType === 1
        ? '/api/userManagement/initDisplayDistrict'
        : '/api/userManagement/initCamera';

    //ローディングマーク表示と合わせて色々再見直ししたほうが良いかも
    this.isShowPage = true;

    let method = 'post';

    // VueStoreに保存した値を見てAPI切り替える
    if (this.$store.state.currentDisplayType === 1) {
      // 対象地区の場合
      const queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        customerNumber: this.$store.state.customerNumber,
        districtSplitNumber: this.$store.state.districtSplitNumber,
      };
      this.backState = '/displayDistrictAccountManagement';
      await this.APP_CU3701(param, queries, method);
    } else if (this.$store.state.currentDisplayType === 2) {
      // カメラの場合
      const queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        deviceID: this.$store.state.deviceID,
      };
      this.backState = '/cameraAccountManagement';
      await this.APP_CU3702(param, queries, method);
    }
    // reset subUserId in store to prevent access by url
    this.$store.commit('setSubUserId', {
      subUserId: '',
    });
  },
};
